import { DataContainer } from './nda-description.interface';

/**
 * v2 `DocumentMetaApi` — extraction output staged against a document by an
 * upload executor (`TermSheetExtractor`, `CreditAgreementExtractor`,
 * `NdaDatesExtractor`, `CovenantExtractor`). Same wire shape as the legacy
 * `DocMetaResponse` (`nda-description.interface.ts`) but sourced from
 * `GET/POST /api/v2/model/DocumentMeta` and the `'DocumentMeta'` WS entity,
 * and typed enough to filter by producer/content-type — `DocMetaResponse`
 * stays in place for the not-yet-migrated v1 callers (`nda`, `covenant`,
 * `closed-deal-entry-method-dialog`, `create-participant-dialog`,
 * `current-deal-entry-method-dialog`).
 */
export enum DocumentMetaDataType {
  NDA = 'NDA',
  TERM_SHEET = 'TERM_SHEET',
  CREDIT_AGREEMENT = 'CREDIT_AGREEMENT',
  COVENANT = 'COVENANT',
}

export interface DocumentMeta {
  _id?: string;
  /** Owning **document** id (not the `*DocumentReference` row's id). */
  document?: string;
  /** Producing extractor's id, e.g. `'TermSheetExtractor'`. */
  source?: string;
  dataType?: DocumentMetaDataType;
  version?: string;
  containers?: DataContainer[];
}
